module.exports = __webpack_public_path__ + "static/media/Startbild_mit_Chart.c4484ffd.png";